import { StatusResponse } from "@rossum/upcloud-costs-shared";

import { getJson } from "./http-client";

export function fetchStatus(): Promise<StatusResponse> {
    return getJson<StatusResponse>("/api/status");
}
